import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function THCIcon() {
  return (
    <SvgIcon sx={{ height: 40, width: 40 }}>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" >
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M272.000000,513.000000 
        C181.355331,513.000000 91.210663,513.000000 1.032996,513.000000 
        C1.032996,342.396973 1.032996,171.793930 1.032996,1.095450 
        C171.561356,1.095450 342.122772,1.095450 512.842102,1.095450 
        C512.842102,171.666550 512.842102,342.333252 512.842102,513.000000 
        C432.793915,513.000000 352.646942,513.000000 272.000000,513.000000 
      M271.933746,469.003082 
        C280.336334,469.006104 288.739319,469.051270 297.141052,468.968567 
        C298.466431,468.955536 299.786163,468.364258 302.019531,468.003571 
        C308.020782,467.349884 314.010468,466.532349 320.027893,466.107971 
        C323.291290,465.877777 326.443573,465.136688 328.224121,470.059845 
        C330.602417,476.635590 334.684204,482.585785 337.901611,488.872589 
        C339.068817,491.153320 340.159485,491.451447 342.476501,490.156586 
        C352.547791,484.528290 362.742035,479.119934 372.894623,473.637299 
        C391.142792,463.782867 409.393799,453.933655 427.641846,444.078979 
        C430.141602,442.728973 432.631287,441.360352 435.036987,440.048706 
        C425.828705,421.360626 419.183838,402.351410 425.279236,382.124084 
        C431.364197,361.931519 446.004120,348.036346 464.204865,337.832794 
        C456.763000,324.184052 449.498474,310.943634 442.314301,297.659698 
        C435.823700,285.658234 429.544617,273.541046 422.953857,261.595367 
        C409.216949,236.697250 395.294128,211.901779 381.529510,187.018860 
        C373.377686,172.282471 365.303894,157.501297 357.387604,142.637695 
        C355.948425,139.935501 354.708679,139.426178 352.099274,140.916748 
        C344.982361,144.982193 337.769135,148.878891 330.598541,152.850510 
        C325.351166,155.756927 320.110870,158.676147 314.955444,161.540741 
        C298.588593,131.636169 282.723938,102.649162 266.716095,73.400551 
        C252.615829,80.853683 239.143295,87.975014 225.743774,95.057747 
        C225.134583,94.489090 224.649368,94.215836 224.425461,93.801392 
        C212.661911,72.026756 200.889648,50.256714 189.198441,28.443222 
        C186.280716,22.999271 184.766739,22.519661 179.491135,25.961422 
        C178.411118,26.666012 177.221924,27.208277 176.166809,27.945261 
        C163.171753,37.022186 149.567078,45.366974 137.402161,55.448219 
        C127.261681,63.851784 118.653313,74.149590 109.656853,83.877083 
        C97.387421,97.143517 87.759293,112.308891 79.332230,128.208542 
        C69.743401,146.300095 62.403389,165.314789 58.076309,185.352554 
        C55.922745,195.325272 53.630138,205.450989 53.238834,215.578537 
        C52.644360,230.964294 53.053497,246.455261 54.171703,261.818909 
        C55.005638,273.276764 57.072769,284.729614 59.585907,295.962067 
        C64.235100,316.741516 71.917572,336.437195 82.408401,355.043121 
        C91.551346,371.258514 102.226006,386.334961 115.211197,399.650452 
        C121.283699,405.877350 127.735710,411.879578 134.707809,417.050446 
        C145.867081,425.326813 157.032150,433.904114 169.246170,440.367310 
        C182.944672,447.616089 197.555130,453.411926 212.255524,458.407745 
        C223.195663,462.125702 234.857391,463.861115 246.299072,465.915131 
        C254.447861,467.377991 262.765076,467.902649 271.933746,469.003082 
      z"/>
      <path fill="#005731" opacity="1.000000" stroke="none" 
        d="
      M271.007111,468.846008 
        C262.765076,467.902649 254.447861,467.377991 246.299072,465.915131 
        C234.857391,463.861115 223.195663,462.125702 212.255524,458.407745 
        C197.555130,453.411926 182.944672,447.616089 169.246170,440.367310 
        C157.032150,433.904114 145.867081,425.326813 134.707809,417.050446 
        C127.735710,411.879578 121.283699,405.877350 115.211197,399.650452 
        C102.226006,386.334961 91.551346,371.258514 82.408401,355.043121 
        C71.917572,336.437195 64.235100,316.741516 59.585907,295.962067 
        C57.072769,284.729614 55.005638,273.276764 54.171703,261.818909 
        C53.053497,246.455261 52.644360,230.964294 53.238834,215.578537 
        C53.630138,205.450989 55.922745,195.325272 58.076309,185.352554 
        C62.403389,165.314789 69.743401,146.300095 79.332230,128.208542 
        C87.759293,112.308891 97.387421,97.143517 109.656853,83.877083 
        C118.653313,74.149590 127.261681,63.851784 137.402161,55.448219 
        C149.567078,45.366974 163.171753,37.022186 176.166809,27.945261 
        C177.221924,27.208277 178.411118,26.666012 179.491135,25.961422 
        C184.766739,22.519661 186.280716,22.999271 189.198441,28.443222 
        C200.889648,50.256714 212.661911,72.026756 224.425461,93.801392 
        C224.649368,94.215836 225.134583,94.489090 225.743774,95.057747 
        C239.143295,87.975014 252.615829,80.853683 266.716095,73.400551 
        C282.723938,102.649162 298.588593,131.636169 314.955444,161.540741 
        C320.110870,158.676147 325.351166,155.756927 330.598541,152.850510 
        C337.769135,148.878891 344.982361,144.982193 352.099274,140.916748 
        C354.708679,139.426178 355.948425,139.935501 357.387604,142.637695 
        C365.303894,157.501297 373.377686,172.282471 381.529510,187.018860 
        C395.294128,211.901779 409.216949,236.697250 422.953857,261.595367 
        C429.544617,273.541046 435.823700,285.658234 442.314301,297.659698 
        C449.498474,310.943634 456.763000,324.184052 464.204865,337.832794 
        C446.004120,348.036346 431.364197,361.931519 425.279236,382.124084 
        C419.183838,402.351410 425.828705,421.360626 435.036987,440.048706 
        C432.631287,441.360352 430.141602,442.728973 427.641846,444.078979 
        C409.393799,453.933655 391.142792,463.782867 372.894623,473.637299 
        C362.742035,479.119934 352.547791,484.528290 342.476501,490.156586 
        C340.159485,491.451447 339.068817,491.153320 337.901611,488.872589 
        C334.684204,482.585785 330.602417,476.635590 328.224121,470.059845 
        C326.443573,465.136688 323.291290,465.877777 320.027893,466.107971 
        C314.010468,466.532349 308.020782,467.349884 301.088989,468.001465 
        C294.676300,468.005676 289.191498,467.909271 283.712830,468.051483 
        C279.473572,468.161469 275.242065,468.570129 271.007111,468.846008 
      M154.163055,229.021759 
        C144.790802,229.000336 135.418564,228.978912 126.015022,228.025986 
        C126.009506,218.055939 126.055824,208.085312 125.948410,198.116364 
        C125.930115,196.418518 125.253143,194.727753 123.958359,193.013931 
        C116.009308,193.020996 108.060249,193.028076 99.449677,193.551926 
        C99.303497,194.191513 99.029961,194.831009 99.029442,195.470718 
        C99.005493,225.110260 98.992111,254.749847 99.050407,284.389282 
        C99.052757,285.584229 99.758904,286.777832 100.586655,287.992096 
        C100.586655,287.992096 101.008041,288.149872 101.644684,288.679962 
        C106.752159,288.786652 111.862282,289.036316 116.966019,288.941559 
        C119.645088,288.891785 122.312958,288.238678 124.993492,287.984772 
        C124.993492,287.984772 124.866524,287.987640 125.527649,287.457977 
        C125.685265,274.976654 125.842880,262.495361 126.937698,250.005203 
        C136.330887,249.986954 145.724091,249.968704 155.036606,249.956619 
        C155.036606,249.956619 155.056564,249.878235 155.020187,250.832260 
        C155.014069,261.539734 154.958878,272.247620 155.052795,282.954193 
        C155.067474,284.629944 155.759995,286.299774 156.587585,287.992096 
        C156.587585,287.992096 157.007904,288.149872 157.644577,288.679962 
        C162.751816,288.786652 167.861725,289.036255 172.965225,288.941650 
        C175.644302,288.891998 178.312195,288.239502 180.992401,287.985291 
        C180.992401,287.985291 180.866211,287.987610 181.526245,287.456787 
        C181.682739,286.653259 181.975388,285.849854 181.976044,285.046173 
        C182.000275,255.573593 182.010559,226.100967 181.950928,196.628479 
        C181.948502,195.429413 181.252167,194.231766 179.957199,193.013962 
        C172.007980,193.021255 164.058762,193.028549 155.447281,193.551529 
        C155.316711,205.407623 155.186127,217.263702 155.036591,229.040878 
        C155.036591,229.040878 155.117111,229.051132 154.163055,229.021759 
      M128.007812,93.006065 
        C128.007812,93.006065 128.131485,93.023499 127.475922,93.555237 
        C127.317749,94.522919 127.022209,95.490494 127.021385,96.458305 
        C126.996559,125.380936 126.990356,154.303619 127.036324,183.226196 
        C127.038315,184.479019 127.562393,185.731018 127.996742,187.415115 
        C127.996742,187.415115 128.029373,187.872116 128.551758,188.530792 
        C134.000504,188.686584 139.450485,188.984909 144.897461,188.937546 
        C147.588959,188.914154 150.274918,188.253265 153.013214,187.422119 
        C153.013214,187.422119 153.165253,186.986496 153.685242,186.344299 
        C153.788589,185.694687 153.981964,185.045105 153.982330,184.395447 
        C153.998291,155.853745 154.007751,127.312035 153.962921,98.770401 
        C153.960953,97.517883 153.443237,96.266174 153.013550,94.585106 
        C153.013550,94.585106 152.962677,94.132774 152.760956,93.615623 
        C152.451477,93.428062 152.141983,93.240494 151.398682,93.002533 
        C151.398682,93.002533 150.989197,92.850632 150.353760,92.319939 
        C146.242355,92.212578 142.125488,91.927246 138.021286,92.053642 
        C134.681137,92.156502 131.356186,92.752510 128.007812,93.006065 
      M233.333221,396.925385 
        C285.523376,368.346283 337.713501,339.767181 389.900055,311.186401 
        C386.359924,304.764984 382.819794,298.343567 378.923767,291.276611 
        C352.327179,305.726074 326.015686,320.020660 299.409729,334.475220 
        C295.289398,327.070740 291.344025,320.106720 287.519806,313.076782 
        C282.610657,304.052399 277.825531,294.960632 272.925842,285.931030 
        C271.746857,283.758240 271.406830,282.354095 274.181732,280.875702 
        C290.803070,272.020416 307.321838,262.972229 323.857208,253.956146 
        C332.536774,249.223511 341.180145,244.424545 349.936737,239.602173 
        C346.078064,232.715393 342.417175,226.181656 338.781677,219.693192 
        C276.996552,253.382141 215.975861,286.654297 154.967041,319.919952 
        C158.736313,326.961578 162.204483,333.440704 165.727280,340.021851 
        C167.878479,338.999298 170.099411,338.076477 172.195892,336.926697 
        C196.069199,323.833771 219.910919,310.683136 243.800751,297.620483 
        C246.431641,296.181946 249.685165,293.781494 251.968018,294.389130 
        C254.319962,295.015167 256.198792,298.574341 257.659332,301.198212 
        C264.919006,314.239960 271.935059,327.417084 279.129089,340.495789 
        C280.611755,343.191284 280.378906,344.739075 277.442963,346.321747 
        C260.480316,355.465790 243.613388,364.787628 226.727295,374.073364 
        C216.093887,379.920715 205.483673,385.810242 195.018021,391.595245 
        C198.692795,398.305084 202.152603,404.622406 205.963043,411.579956 
        C214.889847,406.686096 223.731064,401.839172 233.333221,396.925385 
      M339.057220,365.715485 
        C332.700073,377.742371 327.444824,390.324371 326.243378,403.881897 
        C324.780121,420.393585 328.344116,435.535522 342.718109,446.242493 
        C350.866699,452.312347 359.740723,456.586456 369.876678,457.816650 
        C371.005859,457.953674 373.099976,456.765930 373.433044,455.758362 
        C375.530640,449.412415 377.256805,442.943695 378.748505,437.757507 
        C372.388641,434.177063 365.813416,431.869629 361.117249,427.529144 
        C352.458923,419.526733 354.338867,408.858398 356.737335,398.741547 
        C359.329926,387.805817 364.157776,377.867767 371.311737,369.097931 
        C376.706543,362.484619 384.191162,359.825256 392.044159,360.362671 
        C396.954590,360.698730 401.646545,364.227570 407.066742,366.599518 
        C410.705872,360.934448 414.734467,354.663055 418.740875,348.426208 
        C405.837952,335.537445 383.115814,332.009735 365.545349,340.210114 
        C354.083221,345.559601 346.319031,354.859924 339.057220,365.715485 
      M230.029160,185.481735 
        C239.780212,203.202606 249.617279,220.877167 259.202515,238.687256 
        C260.916382,241.871719 262.380615,242.724396 265.575714,240.794846 
        C272.556610,236.578995 279.668030,232.579239 286.461273,228.644623 
        C272.865723,204.088120 259.309113,179.601990 245.383057,154.448608 
        C246.495941,153.623810 247.473892,152.710388 248.611115,152.088028 
        C254.252762,149.000534 259.990356,146.083221 265.557281,142.868912 
        C266.601349,142.266083 267.926544,140.095825 267.591553,139.475830 
        C264.166595,133.136826 260.425201,126.968803 256.786469,120.777237 
        C232.152664,134.476639 208.082748,147.862427 183.992050,161.259796 
        C188.132675,168.383636 192.104477,175.217041 195.851807,181.664261 
        C203.592072,177.423569 210.590637,173.452301 217.760818,169.819717 
        C218.749954,169.318604 221.334991,170.038361 221.908447,170.973434 
        C224.674255,175.483398 227.004257,180.260651 230.029160,185.481735 
      z"/>
      <path fill="#002C19" opacity="1.000000" stroke="none" 
        d="
      M271.470428,468.924561 
        C275.242065,468.570129 279.473572,468.161469 283.712830,468.051483 
        C289.191498,467.909271 294.676300,468.005676 300.633484,468.019836 
        C299.786163,468.364258 298.466431,468.955536 297.141052,468.968567 
        C288.739319,469.051270 280.336334,469.006104 271.470428,468.924561 
      z"/>
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M232.952759,396.958801 
        C223.731064,401.839172 214.889847,406.686096 205.963043,411.579956 
        C202.152603,404.622406 198.692795,398.305084 195.018021,391.595245 
        C205.483673,385.810242 216.093887,379.920715 226.727295,374.073364 
        C243.613388,364.787628 260.480316,355.465790 277.442963,346.321747 
        C280.378906,344.739075 280.611755,343.191284 279.129089,340.495789 
        C271.935059,327.417084 264.919006,314.239960 257.659332,301.198212 
        C256.198792,298.574341 254.319962,295.015167 251.968018,294.389130 
        C249.685165,293.781494 246.431641,296.181946 243.800751,297.620483 
        C219.910919,310.683136 196.069199,323.833771 172.195892,336.926697 
        C170.099411,338.076477 167.878479,338.999298 165.727280,340.021851 
        C162.204483,333.440704 158.736313,326.961578 154.967041,319.919952 
        C215.975861,286.654297 276.996552,253.382141 338.781677,219.693192 
        C342.417175,226.181656 346.078064,232.715393 349.936737,239.602173 
        C341.180145,244.424545 332.536774,249.223511 323.857208,253.956146 
        C307.321838,262.972229 290.803070,272.020416 274.181732,280.875702 
        C271.406830,282.354095 271.746857,283.758240 272.925842,285.931030 
        C277.825531,294.960632 282.610657,304.052399 287.519806,313.076782 
        C291.344025,320.106720 295.289398,327.070740 299.409729,334.475220 
        C326.015686,320.020660 352.327179,305.726074 378.923767,291.276611 
        C382.819794,298.343567 386.359924,304.764984 389.901855,311.187225 
        C337.713501,339.767181 285.523376,368.346283 232.952759,396.958801 
      z"/>
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M156.109543,193.035858 
        C164.058762,193.028549 172.007980,193.021255 180.473328,193.487274 
        C180.948380,225.302933 180.907288,256.645264 180.866211,287.987610 
        C180.866211,287.987610 180.992401,287.985291 180.522369,287.985962 
        C172.370865,288.041016 164.689377,288.095459 157.007904,288.149872 
        C157.007904,288.149872 156.587585,287.992096 156.298798,287.518921 
        C156.006943,276.157440 156.039963,265.268829 155.958878,254.381073 
        C155.947693,252.877975 155.371292,251.379074 155.056549,249.878235 
        C155.056564,249.878235 155.036606,249.956619 154.853760,249.570648 
        C145.117020,249.178345 135.563126,249.172028 125.588028,249.278320 
        C125.066727,262.256500 124.966621,275.122070 124.866524,287.987640 
        C124.866524,287.987640 124.993492,287.984772 124.523209,287.985718 
        C116.371300,288.041046 108.689674,288.095459 101.008041,288.149872 
        C101.008041,288.149872 100.586655,287.992096 100.297394,287.518860 
        C100.042488,255.708771 100.076843,224.371964 100.111191,193.035141 
        C108.060249,193.028076 116.009308,193.020996 124.474022,193.487411 
        C125.046776,205.640961 125.103859,217.321045 125.272614,229.423477 
        C133.466263,229.896973 141.548630,230.006882 149.629929,229.954514 
        C151.460861,229.942657 153.288147,229.367172 155.117111,229.051132 
        C155.117111,229.051132 155.036591,229.040878 155.426392,228.853577 
        C155.913971,216.789459 156.011765,204.912643 156.109543,193.035858 
      z"/>
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M339.258942,365.395752 
        C346.319031,354.859924 354.083221,345.559601 365.545349,340.210114 
        C383.115814,332.009735 405.837952,335.537445 418.740875,348.426208 
        C414.734467,354.663055 410.705872,360.934448 407.066742,366.599518 
        C401.646545,364.227570 396.954590,360.698730 392.044159,360.362671 
        C384.191162,359.825256 376.706543,362.484619 371.311737,369.097931 
        C364.157776,377.867767 359.329926,387.805817 356.737335,398.741547 
        C354.338867,408.858398 352.458923,419.526733 361.117249,427.529144 
        C365.813416,431.869629 372.388641,434.177063 378.748505,437.757507 
        C377.256805,442.943695 375.530640,449.412415 373.433044,455.758362 
        C373.099976,456.765930 371.005859,457.953674 369.876678,457.816650 
        C359.740723,456.586456 350.866699,452.312347 342.718109,446.242493 
        C328.344116,435.535522 324.780121,420.393585 326.243378,403.881897 
        C327.444824,390.324371 332.700073,377.742371 339.258942,365.395752 
      z"/>
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M229.759003,185.212402 
        C227.004257,180.260651 224.674255,175.483398 221.908447,170.973434 
        C221.334991,170.038361 218.749954,169.318604 217.760818,169.819717 
        C210.590637,173.452301 203.592072,177.423569 195.851807,181.664261 
        C192.104477,175.217041 188.132675,168.383636 183.992050,161.259796 
        C208.082748,147.862427 232.152664,134.476639 256.786469,120.777237 
        C260.425201,126.968803 264.166595,133.136826 267.591553,139.475830 
        C267.926544,140.095825 266.601349,142.266083 265.557281,142.868912 
        C259.990356,146.083221 254.252762,149.000534 248.611115,152.088028 
        C247.473892,152.710388 246.495941,153.623810 245.383057,154.448608 
        C259.309113,179.601990 272.865723,204.088120 286.461273,228.644623 
        C279.668030,232.579239 272.556610,236.578995 265.575714,240.794846 
        C262.380615,242.724396 260.916382,241.871719 259.202515,238.687256 
        C249.617279,220.877167 239.780212,203.202606 229.759003,185.212402 
      z"/>
      <path fill="#FFFFFF" opacity="1.000000" stroke="none" 
        d="
      M150.989197,92.850632 
        C150.989197,92.850632 151.398682,93.002533 151.677429,93.258377 
        C151.956161,93.514229 152.095657,93.971008 152.055725,94.439964 
        C152.010773,125.884033 152.005737,156.859146 151.537262,187.910461 
        C143.392334,187.948486 135.710846,187.910309 128.029373,187.872116 
        C128.029373,187.872116 127.996742,187.415115 127.990990,186.736099 
        C128.033981,155.045883 128.082733,124.034691 128.131470,93.023499 
        C128.131485,93.023499 128.007812,93.006065 128.481750,93.011261 
        C136.300201,92.961174 143.644699,92.905899 150.989197,92.850632 
      z"/>
      <path fill="#002916" opacity="1.000000" stroke="none" 
        d="
      M99.780434,193.293533 
        C100.076843,224.371964 100.042488,255.708771 100.072632,287.508820 
        C99.758904,286.777832 99.052757,285.584229 99.050407,284.389282 
        C98.992111,254.749847 99.005493,225.110260 99.029442,195.470718 
        C99.029961,194.831009 99.303497,194.191513 99.780434,193.293533 
      z"/>
      <path fill="#00371E" opacity="1.000000" stroke="none" 
        d="
      M181.196228,287.722198 
        C180.907288,256.645264 180.948380,225.302933 180.934296,193.497025 
        C181.252167,194.231766 181.948502,195.429413 181.950928,196.628479 
        C182.010559,226.100967 182.000275,255.573593 181.976044,285.046173 
        C181.975388,285.849854 181.682739,286.653259 181.196228,287.722198 
      z"/>
      <path fill="#FE06FE" opacity="1.000000" stroke="none" 
        d="
      M152.000717,187.834259 
        C152.005737,156.859146 152.010773,125.884033 152.274155,94.471405 
        C152.532516,94.033882 152.962677,94.132774 152.962677,94.132774 
        C152.962677,94.132774 153.013550,94.585106 153.016174,95.262726 
        C153.067627,126.289055 153.116440,156.637772 153.165253,186.986496 
        C153.165253,186.986496 153.013214,187.422119 152.744949,187.695663 
        C152.476685,187.969208 152.000717,187.834259 152.000717,187.834259 
      z"/>
      <path fill="#004828" opacity="1.000000" stroke="none" 
        d="
      M127.803696,93.289368 
        C128.082733,124.034691 128.033981,155.045883 127.914253,186.520233 
        C127.562393,185.731018 127.038315,184.479019 127.036324,183.226196 
        C126.990356,154.303619 126.996559,125.380936 127.021385,96.458305 
        C127.022209,95.490494 127.317749,94.522919 127.803696,93.289368 
      z"/>
      <path fill="#004728" opacity="1.000000" stroke="none" 
        d="
      M153.425232,186.665405 
        C153.116440,156.637772 153.067627,126.289055 153.092285,95.477219 
        C153.443237,96.266174 153.960953,97.517883 153.962921,98.770401 
        C154.007751,127.312035 153.998291,155.853745 153.982330,184.395447 
        C153.981964,185.045105 153.788589,185.694687 153.425232,186.665405 
      z"/>
      <path fill="#00341E" opacity="1.000000" stroke="none" 
        d="
      M125.197083,287.722809 
        C124.966621,275.122070 125.066727,262.256500 125.586304,249.490417 
        C126.005775,249.589890 126.000504,250.014038 126.000504,250.014038 
        C125.842880,262.495361 125.685265,274.976654 125.197083,287.722809 
      z"/>
      <path fill="#002715" opacity="1.000000" stroke="none" 
        d="
      M155.038361,250.355255 
        C155.371292,251.379074 155.947693,252.877975 155.958878,254.381073 
        C156.039963,265.268829 156.006943,276.157440 156.074554,287.509033 
        C155.759995,286.299774 155.067474,284.629944 155.052795,282.954193 
        C154.958878,272.247620 155.014069,261.539734 155.038361,250.355255 
      z"/>
      <path fill="#00341E" opacity="1.000000" stroke="none" 
        d="
      M125.160950,229.001114 
        C125.103859,217.321045 125.046776,205.640961 124.935081,193.497314 
        C125.253143,194.727753 125.930115,196.418518 125.948410,198.116364 
        C126.055824,208.085312 126.009506,218.055939 125.809303,228.506897 
        C125.603584,228.987793 125.160950,229.001114 125.160950,229.001114 
      z"/>
      <path fill="#002715" opacity="1.000000" stroke="none" 
        d="
      M155.778412,193.293686 
        C156.011765,204.912643 155.913971,216.789459 155.435867,228.893036 
        C155.186127,217.263702 155.316711,205.407623 155.778412,193.293686 
      z"/>
      <path fill="#001F11" opacity="1.000000" stroke="none" 
        d="
      M125.272621,229.423477 
        C125.160950,229.001114 125.603584,228.987793 125.824951,228.972641 
        C135.418564,228.978912 144.790802,229.000336 154.640076,229.036438 
        C153.288147,229.367172 151.460861,229.942657 149.629929,229.954514 
        C141.548630,230.006882 133.466263,229.896973 125.272621,229.423477 
      z"/>
      <path fill="#01180D" opacity="1.000000" stroke="none" 
        d="
      M126.469101,250.009613 
        C126.000504,250.014038 126.005775,249.589890 126.007507,249.377808 
        C135.563126,249.172028 145.117020,249.178345 154.894104,249.567566 
        C145.724091,249.968704 136.330887,249.986954 126.469101,250.009613 
      z"/>
      <path fill="#00371E" opacity="1.000000" stroke="none" 
        d="
      M151.537262,187.910461 
        C152.000717,187.834259 152.476685,187.969208 152.720032,187.925018 
        C150.274918,188.253265 147.588959,188.914154 144.897461,188.937546 
        C139.450485,188.984909 134.000504,188.686584 128.290558,188.201447 
        C135.710846,187.910309 143.392334,187.948486 151.537262,187.910461 
      z"/>
      <path fill="#003F23" opacity="1.000000" stroke="none" 
        d="
      M101.326363,288.414917 
        C108.689674,288.095459 116.371300,288.041046 124.519409,287.922333 
        C122.312958,288.238678 119.645088,288.891785 116.966019,288.941559 
        C111.862282,289.036316 106.752159,288.786652 101.326363,288.414917 
      z"/>
      <path fill="#003F23" opacity="1.000000" stroke="none" 
        d="
      M157.326233,288.414917 
        C164.689377,288.095459 172.370865,288.041016 180.518738,287.922943 
        C178.312195,288.239502 175.644302,288.891998 172.965225,288.941650 
        C167.861725,289.036255 162.751816,288.786652 157.326233,288.414917 
      z"/>
      <path fill="#004728" opacity="1.000000" stroke="none" 
        d="
      M150.671478,92.585281 
        C143.644699,92.905899 136.300201,92.961174 128.490097,93.073143 
        C131.356186,92.752510 134.681137,92.156502 138.021286,92.053642 
        C142.125488,91.927246 146.242355,92.212578 150.671478,92.585281 
      z"/>
      <path fill="#004728" opacity="1.000000" stroke="none" 
        d="
      M152.861816,93.874199 
        C152.962677,94.132774 152.532516,94.033882 152.314087,94.002441 
        C152.095657,93.971008 151.956161,93.514229 151.894333,93.283577 
        C152.141983,93.240494 152.451477,93.428062 152.861816,93.874199 
      z"/>
      </svg>
    </SvgIcon>
  );
}